import { render, staticRenderFns } from "./SlickItem.vue?vue&type=template&id=8d99aad8&scoped=true&"
import script from "./SlickItem.vue?vue&type=script&lang=js&"
export * from "./SlickItem.vue?vue&type=script&lang=js&"
import style0 from "./SlickItem.vue?vue&type=style&index=0&id=8d99aad8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d99aad8",
  null
  
)

export default component.exports